import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

export const useRiskAssessmentTimelineDialogStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        subtitle: {
            fontSize: "0.8rem",
            fontWeight: theme.typography.fontWeightRegular,
            color: theme.palette.text.secondary,
        },
        timeline: {
            display: "flex",
            flexDirection: "column",
        },
        // Each event is a rail (dot + connector line) beside a content column. The connector line grows to
        // fill the row height, so consecutive events read as one continuous spine.
        entry: {
            display: "flex",
            gap: theme.spacing(2),
        },
        rail: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            flexShrink: 0,
        },
        dot: {
            width: "12px",
            height: "12px",
            borderRadius: "50%",
            marginTop: "5px",
            backgroundColor: theme.palette.primary.main,
        },
        dotPromote: {
            backgroundColor: theme.palette.success.main,
        },
        line: {
            flexGrow: 1,
            width: "2px",
            marginTop: theme.spacing(0.5),
            backgroundColor: theme.palette.divider,
        },
        content: {
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing(1),
            paddingBottom: theme.spacing(3),
            minWidth: 0,
            flexGrow: 1,
        },
        // Marks the event the user clicked in the history table by colouring its spine — the rail dot and the
        // connector line below it — instead of a background box, so the surrounding layout is untouched.
        dotHighlight: {
            backgroundColor: theme.palette.secondary.main,
            boxShadow: `0 0 0 3px ${theme.palette.secondary.light}`,
        },
        lineHighlight: {
            backgroundColor: theme.palette.secondary.main,
            width: "3px",
        },
        header: {
            display: "flex",
            alignItems: "center",
            gap: theme.spacing(1),
            flexWrap: "wrap",
        },
        eventLabel: {
            fontWeight: theme.typography.fontWeightBold,
            color: theme.palette.primary.dark,
        },
        meta: {
            fontSize: "0.75rem",
            color: theme.palette.text.secondary,
        },
        dimensions: {
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: theme.spacing(3),
        },
        dimension: {
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing(1),
        },
        titleLevel: {
            display: "flex",
            alignItems: "center",
            gap: theme.spacing(1),
        },
        label: {
            fontSize: "0.75rem",
            fontWeight: theme.typography.fontWeightBold,
            color: theme.palette.text.secondary,
        },
        value: {
            fontSize: "0.75rem",
            fontWeight: 600,
            color: theme.palette.primary.dark,
        },
        chips: {
            display: "flex",
            flexWrap: "wrap",
            gap: theme.spacing(0.75),
        },
        justification: {
            fontSize: "0.8rem",
            fontStyle: "italic",
            lineHeight: 1.5,
            whiteSpace: "pre-wrap",
            color: theme.palette.text.secondary,
            paddingLeft: theme.spacing(1.5),
            borderLeft: `2px solid ${theme.palette.divider}`,
        },
        detailGrid: {
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing(1),
        },
        detailRow: {
            display: "flex",
            alignItems: "center",
            gap: theme.spacing(1),
            flexWrap: "wrap",
        },
        reason: {
            fontSize: "0.8rem",
            lineHeight: 1.5,
            whiteSpace: "pre-wrap",
            color: theme.palette.text.secondary,
        },
    });
};
